<div class="container flex items-center navigation">
  @for (item of items; track item) {
    <vex-navigation-item [item]="item"></vex-navigation-item>
  }
</div>

